document.addEventListener('turbolinks:load', () => {
    // サイドバーの開閉処理
    $('#js-sidebar').click(function () {
        console.log('sidebar');
        $('.ui.sidebar').sidebar('toggle');
    });
})
